import { render, staticRenderFns } from "./CoursewareBlockExportOptions.vue?vue&type=template&id=f15d43ac&"
import script from "./CoursewareBlockExportOptions.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockExportOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports